import styled from 'styled-components';
import { IframeFullDoc } from 'modules/secureIframe/IframeFullDoc';

export const StyledIframeFullDoc = styled(IframeFullDoc)`
  width: 100%;
  overflow-x: auto;
`;
